import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';
import './index.css';
import App from './App';
import DataSyncManager from './components/DataSyncManager';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <DataSyncManager />
          <BrowserRouter>
            <App />
          </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
